var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssociatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2007_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20C10.6167 20 9.31667 19.7373 8.1 19.212C6.88334 18.6867 5.825 17.9743 4.925 17.075C4.025 16.1757 3.31267 15.1173 2.788 13.9C2.26333 12.6827 2.00067 11.3827 2 10C1.99933 8.61733 2.262 7.31733 2.788 6.1C3.314 4.88267 4.02633 3.82433 4.925 2.925C5.82367 2.02567 6.882 1.31333 8.1 0.788C9.318 0.262667 10.618 0 12 0C13.382 0 14.682 0.262667 15.9 0.788C17.118 1.31333 18.1763 2.02567 19.075 2.925C19.9737 3.82433 20.6863 4.88267 21.213 6.1C21.7397 7.31733 22.002 8.61733 22 10C21.998 11.3827 21.7353 12.6827 21.212 13.9C20.6887 15.1173 19.9763 16.1757 19.075 17.075C18.1737 17.9743 17.1153 18.687 15.9 19.213C14.6847 19.739 13.3847 20.0013 12 20ZM9.5 11.5C10.4667 11.5 11.2917 11.1583 11.975 10.475C12.6583 9.79167 13 8.96667 13 8C13 7.03333 12.6583 6.20833 11.975 5.525C11.2917 4.84167 10.4667 4.5 9.5 4.5C8.53333 4.5 7.70833 4.84167 7.025 5.525C6.34167 6.20833 6 7.03333 6 8C6 8.96667 6.34167 9.79167 7.025 10.475C7.70833 11.1583 8.53333 11.5 9.5 11.5ZM16.5 12.5C17.2 12.5 17.7917 12.2583 18.275 11.775C18.7583 11.2917 19 10.7 19 10C19 9.3 18.7583 8.70833 18.275 8.225C17.7917 7.74167 17.2 7.5 16.5 7.5C15.8 7.5 15.2083 7.74167 14.725 8.225C14.2417 8.70833 14 9.3 14 10C14 10.7 14.2417 11.2917 14.725 11.775C15.2083 12.2583 15.8 12.5 16.5 12.5ZM12 18C13.4167 18 14.7083 17.6667 15.875 17C17.0417 16.3333 17.9833 15.45 18.7 14.35C18.35 14.25 17.9917 14.1667 17.625 14.1C17.2583 14.0333 16.8833 14 16.5 14C15.6167 14 14.55 14.2583 13.3 14.775C12.05 15.2917 11.05 16.3083 10.3 17.825C10.5833 17.8917 10.8667 17.9377 11.15 17.963C11.4333 17.9883 11.7167 18.0007 12 18ZM8.825 17.35C9.40833 16.15 10.071 15.2583 10.813 14.675C11.555 14.0917 12.1173 13.7 12.5 13.5C12.0167 13.35 11.529 13.2293 11.037 13.138C10.545 13.0467 10.0327 13.0007 9.5 13C8.75 13 8.00834 13.0917 7.275 13.275C6.54167 13.4583 5.83333 13.7167 5.15 14.05C5.58333 14.7667 6.11267 15.4127 6.738 15.988C7.36333 16.5633 8.059 17.0173 8.825 17.35Z",
    fill: "#F6764E",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2007_292",
    x: -2,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_292",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociatesIcon);
export default __webpack_public_path__ + "static/media/associatesIcon.5083057241e2f7cda8105c3fad6b5562.svg";
export { ForwardRef as ReactComponent };